import { defineComponent as _defineComponent } from 'vue'
import { EquipmentFilterValues } from '@/views/careConsole/commons/model';
import { areArraysEqual } from '@/utils/array';
import CustomTableFilters from '@/components/tableWithActions/CustomTableFilters.vue';
import { useI18n } from '@/composables/i18n';
import { computed, ComputedRef } from 'vue';
import { isBooleanString } from '@/utils/misc';
import { useTableFilters } from '@/composables/table-filters';


export default /*#__PURE__*/_defineComponent({
  __name: 'EquipmentFilters',
  emits: ["filters-change"],
  setup(__props, { expose, emit }: { emit: ((
      e: 'filters-change',
      filters: EquipmentFilterValues,
      areApplying: boolean,
    ) => void), expose: any, slots: any, attrs: any }) {



const defaultFilterValues: EquipmentFilterValues = Object.freeze({
  mySubscriptions: false,
  noSubscriptions: false,
  customerName: [],
  name: [],
  model: [],
  equipmentNumber: [],
  locationName: [],
  subsidiaryName: [],
  subscribers: [],
});

const areApplying: ComputedRef<boolean> = computed<boolean>(() => {
  return (
    areTextListFiltersApplying.value ||
    filters.value.mySubscriptions ||
    filters.value.noSubscriptions
  );
});

const {
  filters,
  clearAllFilters,
  onFiltersApplied,
  updateFiltersFromUrlQueryParameters,
} = useTableFilters(
  defaultFilterValues,
  (value) => value,
  queryParameterDeserializer,
  areApplying,
  emit,
);
const { t } = useI18n();

function queryParameterDeserializer(key: keyof EquipmentFilterValues, value: any) {
  if (TEXT_LIST_FILTERS.includes(key)) {
    return Array.isArray(value) ? value : ([value] as any);
  } else if (isBooleanString(value)) {
    return JSON.parse(value);
  }
}

const areTextListFiltersApplying: ComputedRef<boolean> = computed<boolean>(() =>
  TEXT_LIST_FILTERS.some(
    (textListFilterKey) =>
      !areArraysEqual(
        filters.value[textListFilterKey] as string[],
        defaultFilterValues[textListFilterKey] as string[],
      ),
  ),
);

const TEXT_LIST_FILTERS = [
  'customerName',
  'name',
  'model',
  'equipmentNumber',
  'locationName',
  'subsidiaryName',
  'subscribers',
] as Array<keyof EquipmentFilterValues>;

expose({
  clearAllFilters,
  updateFiltersFromUrlQueryParameters, // public for testing
});

return { __sfc: true,emit, defaultFilterValues, areApplying, filters, clearAllFilters, onFiltersApplied, updateFiltersFromUrlQueryParameters, t, queryParameterDeserializer, areTextListFiltersApplying, TEXT_LIST_FILTERS, CustomTableFilters }
}

})